import React, { Component } from 'react'

import { Provider } from 'mobx-react'
import { Router as ReactRouter } from 'react-router-dom'

import Router from 'src/router'
import history from 'src/router/history'
import storeInstance from 'src/store/instance'
import { theme, ThemeProvider } from 'src/styles'
import GlobalStyles from 'src/styles/global'

import GoogleAnalytics from 'src/utils/analytics/google-analytics/initialization'
import FacebookAnalytics from 'src/utils/analytics/facebook-analytics/initialization'
import AmplitudeAnalytics from 'src/utils/analytics/amplitude-analytics/initialization'

import 'assets/css/font.css'

class App extends Component {
  public render() {
    // @todo maybe need to move analytics initializers to specific page(s)
    return (
      <>
        <GoogleAnalytics/>
        <FacebookAnalytics/>
        <AmplitudeAnalytics/>
        <ThemeProvider theme={theme}>
          <Provider store={storeInstance.get()}>
            <ReactRouter history={history}>
              <Router/>
            </ReactRouter>
          </Provider>
          <GlobalStyles/>
        </ThemeProvider>
      </>
    )
  }
}

export default App
